import React, { Dispatch, SetStateAction } from 'react';
import { MenuItem } from '../Menu/VoxelMenu';
import VoxelToggleButton from './VoxelToggleButton';

export interface VoxelToggleTabsProps {
  menuListItems: MenuItem[];
  selectedId: any;
  setSelectedId: Dispatch<SetStateAction<any>>;
}

export const VoxelToggleTabs: React.FC<VoxelToggleTabsProps> = ({
  menuListItems,
  selectedId,
  setSelectedId,
}) => {

  return (
    <div className={`flex flex-row flex-nowrap`}>
      {menuListItems.filter(m => !m.disabled).map(tab => {
        return (
          <VoxelToggleButton
            key={tab.id}
            onClick={() => setSelectedId(tab.id)}
            title={tab.name}
            selected={selectedId === tab.id}
          />
        );
      })}
    </div>
  );
};

export default VoxelToggleTabs;
